export default async function () {
  const carrierFleetStore = useCarrierFleetStore();
  await carrierFleetStore.getCarrierFleetInfo();
}
